// extracted by mini-css-extract-plugin
export default {"text":"aKUq77k7tkI3LkB10AJ2","revealable":"plIAI7tLcWQZ7Eamow68"};